module.exports = __webpack_public_path__ + "img/Barion-card-strip-intl_large.197e497.png";